// libraries.
import { useState } from "react";

// hooks.
import { useProcessNids } from "./useProcessNids.hook";

// styles.
import { StyledWrapper } from "./styles";

export const NidInput = () => {
  const [nids, setNids] = useState<string>("");
  const { isProcessing, progress, processNids } = useProcessNids();

  const handleSubmit = async () => {
    const success = await processNids(nids);

    if (success) {
      setNids("");
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNids(e.target.value);
  };

  return (
    <StyledWrapper className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3 title-text">Ingreso de NIDs</h5>
        <div className="mb-3">
          <label htmlFor="nidsTextarea" className="form-label text-label">
            NIDs (separados por comas)
          </label>
          <textarea
            id="nidsTextarea"
            className="form-control text-area"
            rows={6}
            placeholder="Ejemplo: 12345, 67890, 11223, 44556"
            value={nids}
            onChange={handleChange}
            disabled={isProcessing}
          />
          <div className="form-text text-help">
            Ingresa los NIDs separados por comas
          </div>
        </div>

        {isProcessing && progress.total > 0 && (
          <div className="mb-3">
            <div className="progress-text text-label mb-2">
              Procesando: {progress.current} de {progress.total} NIDs
            </div>
            <div className="progress" style={{ height: "8px" }}>
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{
                  width: `${(progress.current / progress.total) * 100}%`,
                }}
                aria-valuenow={progress.current}
                aria-valuemin={0}
                aria-valuemax={progress.total}
              />
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-habi rounded-5 p-2 submit-button"
            style={{ width: "25%" }}
            onClick={handleSubmit}
            disabled={!nids.trim() || isProcessing}
          >
            {isProcessing ? "Procesando..." : "Enviar"}
          </button>
        </div>
      </div>
    </StyledWrapper>
  );
};
